import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { updateProduct } from 'api/auth.api';

export const useUpdateProduct = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updateProduct,

    onSuccess: (res) => {
      toast({
        title: 'Product updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to update',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
